<script>
import tableEmpty from "@/components/table-empty.vue";
import raPagination from "@/components/ra-pagination.vue";
import editAds from "@/view/Ads/edit-ads.vue";
import {getAdList} from "@/api/ads";
export default {
  name: "Ad-page",
  components: {
    tableEmpty,
    raPagination,
    editAds,
  },
  data() {
    return {
      tableData: [],
      editData: {},
      loading: true,
      searchQuery: {
        page: 1,
      },
      total: 0,
      column: [
        { label: "AD description", prop: "description" },
        { label: "Picture", prop: "picture" },
        { label: "Size", prop: "size" },
        { label: "Priority", prop: "priority" },
        // { label: "ID", prop: "id" },
      ]
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    updateList() {
      this.getList();
    },
    getList() {
      this.loading = true;
      getAdList({ limit: 10, ...this.searchQuery }).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    editHandler(row) {
      this.editData = row;
      this.$refs.editAds.dialogFormVisible = true;
    },
    pageHandler(page) {
      this.searchQuery.page = page;
      this.getList();
    }
  }
}
</script>

<template>
  <div v-loading="loading">
    <el-table
        v-if="tableData.length"
        :data="tableData"
    >
      <el-table-column
          v-for="(item, index) in column"
          :label="item.label"
          :prop="item.key"
          :key="index"
          :width="item.minWidth"
      >
        <template v-slot:default="scope">
          <template v-if="item.prop === 'picture'">
            <div>
              <el-image class="w-[60px] h-[40px]" :src="scope.row.picture" alt="" fit="cover" :preview-src-list="[scope.row.picture]"></el-image>
            </div>
          </template>
          <template v-else>
            <span>{{ scope.row[item.prop] }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
          label="Action"
      >
        <template slot-scope="scope">
          <div class="action">
            <span @click="editHandler(scope.row)" class="cursor-pointer">
              <img src="../../assets/zipCode/edit@2x.png" class="w-4 mr-4" alt="">
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <table-empty v-else></table-empty>
    <ra-pagination
        :currentPage="searchQuery.page"
        :list-length="tableData.length"
        @pageChange="pageHandler"
        :total="total"
    ></ra-pagination>
    <edit-ads
        @updateList="updateList"
        ref="editAds"
        :row-data="editData"
    ></edit-ads>
  </div>
</template>

<style scoped lang="less">

</style>
